
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconDefault as ObiSimplifiedBeaconDefaultElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-default.js';
 
 
 

 
 export const ObiSimplifiedBeaconDefault = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-default',
   elementClass: ObiSimplifiedBeaconDefaultElement,
   events: {
     
   }
  });
 
 